// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  basePath: '',
  webComponent: false,
  oneSignalAppId: 'f283696e-da31-4f23-be3d-abe9c61da065',
  oneSignalAllowedOrigins: [
    'http://localhost:4200',
    'https://app-01-orgapp-sn-dev-ui.azurewebsites.net',
    'https://weingartenolten.sanesquare.ch/'
  ],
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
